module.exports = __webpack_public_path__ + "img/119.5.233385d8.png";